import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";

// initial load User Profile/Two-Factor Authentication page
const getMfaUserInfo = async (token) => {

  let status = STATUSES.SUCCESS;
  let body = {};

  const url = "/api/mfa/getUserSmsFactorMobile";
  //const url = "/api/mfa/getUserFactors";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    //console.log("getMfaUserInfo()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// Set token via phone (if phone number provided) or email
const setupUserSmsFactor = async (token, request) => {

  let status = STATUSES.SUCCESS;
  let body = request;

  const url = "/api/mfa/setupUserSmsFactor";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {
    //console.log("setupUserSmsFactor()", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};


// initial load User Profile/Two-Factor Authentication page
const getUserFactors = async (token) => {

  let status = STATUSES.SUCCESS;
  let body = {};

  const url = "/api/mfa/getUserFactors";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// verify the mfa
const verifyLoggedInUserFactor = async (token, mfaToken, userFactor, isEmailVerified) => {

  let status = STATUSES.SUCCESS;
  /*{
    "userFactor":SMS,EMAIL
    "token":mfaToken
  }*/
  let body = {
    "userFactor": userFactor,
    "token": mfaToken,
    "isEmailVerified": isEmailVerified
  }

  const url = "/api/mfa/verifyUserFactorToken";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};


// disable the mfa
const disableUserFactor = async (token, userFactor) => {

  let status = STATUSES.SUCCESS;
  /*{
    "userFactor":SMS,EMAIL
    "token":mfaToken
  }*/
  let body = {
    "userFactor": userFactor,
  }

  const url = "/api/mfa/disableUserFactor";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

export { getMfaUserInfo, setupUserSmsFactor, getUserFactors, verifyLoggedInUserFactor, disableUserFactor };